export const MAAS_TASK_TEMPLATE_FIELD_KEYS = {
  list: 'mi.taskTemplate.list',
} as const;

export const MAAS_TASK_TEMPLATE_ACTION_KEYS = {
  add: 'mi.taskTemplate.add',
  edit: 'mi.taskTemplate.edit',
  remove: 'mi.taskTemplate.remove',
} as const;

export const MAAS_TASK_TEMPLATE_FIELD_KEY_LIST = Object.values(MAAS_TASK_TEMPLATE_FIELD_KEYS);
export const MAAS_TASK_TEMPLATE_ACTION_KEY_LIST = Object.values(MAAS_TASK_TEMPLATE_ACTION_KEYS);
